/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { gql } from '@apollo/client';

const findExperienceInboxQuery = (queryName = 'experienceOfferInbox', withTargeting = false) => (
    gql`query ${queryName}(
    $brand: String!
    $environment: String!
    $user: UserSF!
    $userAttributes: [UserAttributesSF]
    $resolveIdentity: Boolean!
    ${withTargeting ? '$targeting: TargetingSF!' : ''}
  ) {
    experienceOfferInbox(
      brand: $brand
      environment: $environment
      user: $user
      userAttributes: $userAttributes
      resolveIdentity: $resolveIdentity
      ${withTargeting ? 'targeting: $targeting' : ''}
    ) {
      availableOffers {
        source
        type
        name
        promoCode
        value
        content
        experimentTracking
      }
      content
      }
  }`
);

export default findExperienceInboxQuery;
